import { Flex, Form, Typography } from 'antd'
import styled from 'styled-components'

export const FormItem = styled(Form.Item)`
  .ant-form-item-additional {
    margin-top: 4px;
  }
  .ant-form-item-explain-error {
    font-size: 12px;
  }
`

export const SuccessText = styled(Flex)`
  .ant-typography-success {
    font-size: 12px;
  }
`

export const HelpText = styled(Typography.Text)`
  font-size: 12px;
`
